export const X_UI_WIDGET = 'x-ui-widget';
export const X_UI_FORMAT = 'x-ui-format';

export const IMAGE_SELECT_WIDGET = 'ImageSelectArrayWidget';
export const JSON_POINTER_FORMAT = 'json-pointer';
